  /*============Build and Price Controller
      ================================*/
  angular
    .module('vppApp')
    .controller('buildPriceController', buildPriceController);

  buildPriceController.$inject = ['$scope', '$rootScope', '$stateParams', 'vppConfig', '$sce', 'VarientService', '$httpParamSerializer', '$timeout', '$element', '$q'];

  function buildPriceController($scope, $rootScope, $stateParams, vppConfig, $sce, VarientService, $httpParamSerializer, $timeout, $element, $q) {
    var varient = VarientService.getVarientName();
    var URL;

    var mapping = {
      emp:  'family-first',
      ded:  'dealership-employee',
      cgp:  'college',
      gmed: 'educator',
      mpp:  'military',
      sup:  'supplier',
      frd:  'first-responder'
    };

    // added for posterity, but
    // commented out for 2020 SOTY
    // 8/28/20 BPR
    // if (varient) {
      // URL = vppConfig.buildPricevarient[varient];
    // } else {
      URL = domainPath + '/byo-vc/client/' + mapping[domainAbbr] + '/en/US';
    // }

    $rootScope.buildPricePath = $sce.trustAsResourceUrl(URL);

  }
